class Unidad
{
	id = null;
    alias = '';
    unidad = null;
    partido_partida = null;
    factura_digital = null;
    debito_auto_plan = null;
    debito_auto_gral = null;
    direccion = null;
    direccion_usuario = null;
    nombre_usuario = null;
    ws_usuario = null;

    constructor(obj) {    
	    // IF AN OBJECT WAS PASSED THEN INITIALISE PROPERTIES FROM THAT OBJECT
        for (var prop in obj) this[prop] = obj[prop];
        
        this.direccion = this.direccion.replaceAll('<br>', ', ');
        if(this.alias == null){
            this.alias = '';
        }
  	}
}

export default Unidad;